import React, { Component } from 'react'
import { Helmet } from "react-helmet-async";
import { decode } from 'he';

class MetaHeader extends Component {
  render() {
    const { p, site } = this.props
    
    if(!p) return null

    return (
      <Helmet
        defaultTitle={decode(p.seo.title !== '' ? p.seo.title : p.title.rendered)}
        meta={[
          {
            name: 'description',
            content: p.seo.metadesc !== '' ? p.seo.metadesc : p.excerpt.rendered
          },
          {
            name: 'og:title',
            content: p.seo['opengraph-title'] !== '' ? p.seo['opengraph-title'] : p.title.rendered
          },
          {
            name: 'og:description',
            content:
              p.seo['opengraph-description'] !== ''
                ? p.seo['opengraph-description']
                : p.excerpt.raw || p.excerpt.rendered
          },
          {
            name: 'og:site_name',
            content: `Democratic Alliance - ${site.province.title.rendered}`
          },
          { name: 'og:type', content: `business` },
          { name: 'og:image', content: p.seo['opengraph-image'] || null },
          { name: 'fb:app_id', content: '1262049647255981' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: `@${site.options.twitterHandle}` },
          {
            name: 'twitter:title',
            content: p.seo['twitter-title'] !== '' ? p.seo['twitter-title'] : p.title.rendered
          },
          {
            name: 'twitter:description',
            content:
              p.seo['twitter-description'] !== ''
                ? p.seo['twitter-description']
                : p.excerpt.raw || p.excerpt.rendered
          },
          {
            name: 'twitter:image',
            content: p.seo['twitter-image'] !== '' ? p.seo['twitter-image'] : null
          }
        ]}
        htmlAttributes={{ lang: 'en' }}
      />
    )
  }
}

export default MetaHeader
